import { Component, OnInit, AfterViewInit, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginService, HttpStatusCode } from '@serengeti/serengeti-common';
import { AlertService } from 'src/app/utility/alert/alert.service';
import { CodeService } from '@serengeti/serengeti-code';
import { environment } from 'src/environments/environment';

@Component({
	selector: 'app-member-login',
	templateUrl: './login.component.html',
	styleUrls: ['./login.component.css']
})
export class MemberLoginComponent implements OnInit, AfterViewInit {
	model: any = {};

	environment = environment;
	loading = false;
	returnUrl: string;
	profile: string;

	@ViewChild('loginid', { static: false }) username: ElementRef;

	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private loginService: LoginService,
		private alertService: AlertService,
		private codeService: CodeService
	) {
		this.profile = environment.profile;
	}

	ngOnInit() {
		// reset login status
		this.loginService.logout();

		// get return url from route parameters or default to '/'
		this.returnUrl = this.route.snapshot.queryParamMap.get('returnUrl') || '/';
	}

	ngAfterViewInit() {
		this.username.nativeElement.focus();
	}

	login() {
		this.loading = true;
		this.loginService.login(this.model.username, this.model.password)
			.subscribe((user: any) => {
					this.codeService.find('SystemProfile', this.environment.profile).subscribe((profileContent: any) => {
						try {
							this.environment.content = JSON.parse(profileContent.detailInfo);
							this.loginService.setScreenConfig('login', 'profile', this.environment.content);
						} catch (error) {
							console.log(error);
							console.log(profileContent.detailInfo);
						}
						this.router.navigateByUrl(this.returnUrl);
					}, () => {
						this.router.navigateByUrl(this.returnUrl);
					});
				},
				error => {
						switch (error.status) {
							case HttpStatusCode.LOCKED:
								this.alertService.error('Your account is locked.');
								break;
							default:
								this.alertService.error('Failed to login !!!<br/>Please verify your login Id or password !!!');
								break;
						}
						this.loading = false;
				});
	}
}
